module.exports = __webpack_public_path__ + "static/media/intro-photowall-1.22e112e0.jpg";